var render, staticRenderFns
import script from "./customer_meterial.vue?vue&type=script&lang=js"
export * from "./customer_meterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ac3fd7a')) {
      api.createRecord('2ac3fd7a', component.options)
    } else {
      api.reload('2ac3fd7a', component.options)
    }
    
  }
}
component.options.__file = "found/views/mdm/views/customer_meterial/customer_meterial.vue"
export default component.exports